import type { TThunkAction } from 'shared/types/redux';
import { ECPDDraftStatus, EDealType, type TCPDDraftSource } from 'shared/types/redux/cpd';
import { createCPDDraft as createCPDDraftService } from 'shared/api/cpd/createCPDDraft';
import { selectCPDDraftSource, selectCPDDealType } from 'shared/selectors/cpd';

import { setCpdDraftId, setCpdDraftStatus } from './actions';

interface ICreateCPDDraftParams {
  phone: string | null;
  legalAgreementAccepted?: boolean | null;
}

export const createCPDDraft =
  (params: ICreateCPDDraftParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const state = getState();

    const source = selectCPDDraftSource(state) as TCPDDraftSource;
    const dealType = selectCPDDealType(state) as EDealType;

    const parameters = { phone: params.phone, source, dealType, legalAgreementAccepted: params.legalAgreementAccepted };

    dispatch(setCpdDraftStatus(ECPDDraftStatus.Loading));

    const response = await createCPDDraftService({ httpApi, logger, parameters });

    if (response.isSuccess) {
      dispatch(setCpdDraftId(response.cpdDraftId));
      dispatch(setCpdDraftStatus(ECPDDraftStatus.Success));

      return;
    }

    dispatch(setCpdDraftStatus(ECPDDraftStatus.Fail));
  };
